<template>
<div>
    <div class="row" v-if="$gate.isAdmin() || $gate.isReception() || $gate.isAccount() || $gate.isManager() || $gate.isSupervisor()">
        <div id="pdf" class="col-12">
            <div class="row mb-2">
                <div class="col-md-4"></div>
                <div class="col-md-4 d-flex justify-content-center">

                    <img src="./../Images/StepUp_logo.png" alt="StepUp" style="background-size: cover;width: auto; height: 150px;">
                </div>
                <div class="col-md-4"></div>
            </div>
            <div class="col-md-12 row mt-5">
                <div class="col-md-6">
                    <input id="saleDate" type="date" v-model="filters.date" class="form-control" @input="dailySales()">
                </div>


            </div>

            <div class="col-md-12 mt-5">
                 <h4 class="text-center">
                     <span v-if="vid === '34'">Spring Souk</span>
                     <span v-else-if="vid === '47'">Arabian Ranches III</span>
                 </h4>
                 <h4 class="text-center">Sales Date: {{filters.date}}</h4>
                  <div class="alert alert-danger col-md-12 text-center" role="alert" v-if="hasExistingDailySale">
                    Transactions for {{filters.date}} has already been submitted to EMAAR. You may resubmit to overwrite the existing values.
                </div>
            </div>
            <div class="col-md-12 mt-5">
                <div class="well"><h5>Services Report</h5></div>
                <table class="table table-bordered table-condensed">
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Transaction Number</th>
                            <th>Customer</th>
                            <th>Payment Method</th>
                            <th>Item</th>
                            <th>Status</th>
                            <th>Taxable</th>
                            <th>Discount</th>
                            <th>VAT 5%</th>
                            <th>Total</th>
                            <th>Cashier</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="transaction in transactions" :key="transaction.id">
                            <td> {{transaction.date}} </td>
                            <td> STEP - {{transaction.id}} </td>
                            <th> {{transaction.customer}}</th>
                            <td> {{transaction.payment}} </td>
                            <td> {{transaction.quantity}} </td>
                            <td> {{transaction.status}} </td>
                            <td> {{transaction.taxable}} </td>
                            <td> {{transaction.discount}} </td>
                            <td> {{transaction.vat}} </td>
                            <td> {{transaction.total}} </td>
                            <td> {{transaction.cashier}} </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td> <strong> {{parseFloat(taxable).toFixed(2)}} AED </strong></td>
                            <td> <strong> {{parseFloat(discount).toFixed(2)}} AED </strong></td>
                            <td> <strong> {{parseFloat(vat).toFixed(2)}} AED </strong></td>
                            <td> <strong> {{parseFloat(total).toFixed(2)}} AED </strong></td>
                        </tr>
                    </tfoot>
                </table>
            </div>


            <div class="col-md-12">
                <div class="well"><h5>Products Report</h5></div>
                <table class="table table-bordered table-condensed">
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Transaction Number</th>
                            <th>Product Name</th>
                            <th>Quantity</th>
                            <th>Taxable</th>
                            <th>Discount</th>
                            <th>VAT 5%</th>
                            <th>Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="product in products" :key="product.id">
                                  <td> {{product.date}} </td>
                            <td> {{product.id}} </td>
                            <td> {{product.productname}} - {{product.optionname}} </td>
                            <td> {{product.quantity}} </td>
                            <td> {{product.Taxable}} </td>
                            <td> {{product.discount}} </td>
                            <td> {{product.VAT}} </td>
                            <td> {{product.price}} </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td> <strong> {{parseFloat(productTaxable).toFixed(2)}} AED </strong></td>
                            <td> <strong> {{parseFloat(productDiscount).toFixed(2)}} AED </strong></td>
                            <td> <strong> {{parseFloat(productVat).toFixed(2)}} AED </strong></td>
                            <td> <strong> {{parseFloat(productTotal).toFixed(2)}} AED </strong></td>
                        </tr>
                    </tfoot>
                </table>
            </div>


            <div class="col-md-12">
                <div class="well"><h5>Other Services Report</h5></div>
                <table class="table table-bordered table-condensed">
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Transaction Number</th>
                            <th>Product Name</th>
                            <th>Quantity</th>
                            <th>Taxable</th>
                            <th>Discount</th>
                            <th>VAT 5%</th>
                            <th>Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="product in otherServices" :key="product.id">
                            <td> {{product.date}} </td>
                            <td> {{product.id}} </td>
                            <td> {{product.title}} - {{product.name}} </td>
                            <td> {{product.quantity}} </td>
                            <td> {{product.Taxable}} </td>
                            <td> {{product.discount}} </td>
                            <td> {{product.VAT}} </td>
                            <td> {{product.price}} </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td> <strong> {{parseFloat(otherServiceTaxable).toFixed(2)}} AED </strong></td>
                            <td> <strong> {{parseFloat(otherServiceDiscount).toFixed(2)}} AED </strong></td>
                            <td> <strong> {{parseFloat(otherServiceVat).toFixed(2)}} AED </strong></td>
                            <td> <strong> {{parseFloat(otherServiceTotal).toFixed(2)}} AED </strong></td>
                        </tr>
                    </tfoot>
                </table>
            </div>

            <div class="col-md-12">
                <div class="well"><h5>Transaction Summary</h5></div>
                <table class="table table-bordered table-responsive">
                    <tbody>
                        <tr>
                            <td>Total Transaction Count: </td>
                            <td>{{totalTransactionCount}}</td>
                        </tr>

                        <tr>
                            <td>Total Transaction Amount: </td>
                            <td>{{totalTransactionAmount}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="col-md-12" >
            <div class="col-12">
                <button class="btn btn-primary float-right"  @click="confirmSubmit">Submit to EMAAR</button>
            </div>


        </div>
    </div>
        <div v-else>
            <notfound></notfound>
        </div>
</div>


</template>


<script>
import Swal from 'sweetalert2'
export default {

    data(){
        return {
            vid: 0,
            transactions:[],
            products:[],
            payments:[],
            cancelled: [],
            refunded: [],
            users:[],
            drawers: '',
            filters: {
                date: this.$root.myDate,
                draw: 0,
                user: '',
                user_id: this.$root.id,
                name: this.$root.staffname,
            },
            hide: false,
            hasExistingDailySale: false,
            otherServices: []


        }
    },
    created(){
        this.dailySales();

    },
    mounted(){
         this.vid = new URLSearchParams(window.location.search).get("vid");
         this.setMaxDate();
    },
    methods: {
        dailySales(url = './api/Emaar/Daily-Sales?vid=' + new URLSearchParams(window.location.search).get("vid")) {
            let self = this;
            this.filters.draw++
            axios
            .get(url, {params:this.filters})
            .then((result) => {
                console.log(result.data)
                this.transactions = result.data.transactions
                this.products = result.data.products
                this.otherServices = result.data.otherProducts;

                self.checkExistingDailySale();

            }).catch((err) => {
                console.log(err)
            });
        },
        checkExistingDailySale(){
                let self = this;
                axios.post("./api/Emaar/Check-Exist-Daily?vid=" +  new URLSearchParams(window.location.search).get("vid"),
                    {
                        salesDate: this.filters.date,
                    }
                    )
                .then(response => {
                    console.log(response);
                     self.hasExistingDailySale = response.data.result;
                })
        },
        confirmSubmit(){
            let self = this;
            Swal.fire({
                title: 'Are you sure you want to submit this transaction to EMAAR?',
                showDenyButton: true,
                showCancelButton: true,
                showLoaderOnConfirm: true,
                 html:
                'Transaction Count: <b>' + this.totalTransactionCount + '</b></br>' +
                'Transaction Amount: <b>' + this.totalTransactionAmount + '</b></br>'
                ,
                confirmButtonText: 'Submit',
                denyButtonText: 'Cancel',
                preConfirm: () => {
                    return axios.post("./api/Emaar/Daily-Sales/submit",
                        {
                            transactionCount: self.totalTransactionCount,
                            transactionAmount: self.totalTransactionAmount,
                            salesDate: self.filters.date,
                            submittedBy: self.filters.name,
                            vid: new URLSearchParams(window.location.search).get("vid")
                        }
                     )
                    .then(response => {
                        if(response.data.result != true){
                            console.log(response.data.error)
                            throw new Error(response.data.error)
                        }
                        return response.data.result;
                    })
                    .catch(error => {
                        Swal.showValidationMessage(
                        `Request failed: ${error}`
                        )
                    })
                },
                allowOutsideClick: () => !Swal.isLoading()
                }).then((result) => {
                    if (result.value) {
                        Swal.fire('Transaction submitted to Emaar!', '', 'success')
                    }
                })
        },
        submitToEmaar(){

             axios.post("./api/Emaar/Daily-Sales/submit",
             {
                transactionCount: this.totalTransactionCount,
                transactionAmount: this.totalTransactionAmount,
                salesDate: this.filters.date,
                submittedBy: this.filters.name
             }
            )
            .then((result) => {
                if(result.data.result == true){
                    Swal.fire('Transaction submitted to Emaar!', '', 'success')
                }else{
                    Swal.fire({
                        icon: 'error',
                        text: 'Something went wrong! Please contact IT.',
                    })
                    console.log(result.error)
                }
            }).catch((err) => {
                 Swal.fire({
                        icon: 'error',
                        text: 'Something went wrong! Please contact IT.',
                })
                console.log(err)
            });
        },
        setMaxDate(){
             var dtToday = new Date();

            var month = dtToday.getMonth() + 1;
            var day = dtToday.getDate();
            var year = dtToday.getFullYear();

            if(month < 10)
                month = '0' + month.toString();
            if(day < 10)
                day = '0' + day.toString();

            var maxDate = year + '-' + month + '-' + day;
            document.getElementById("saleDate").setAttribute('max', maxDate);
        }
    },
    computed: {
        taxable() {
            return this.transactions.reduce((total, item) => {
                return total + Number(item.taxable)
            }, 0)
        },
        discount() {
            return this.transactions.reduce((total, item) => {
                return total + Number(item.discount)
            }, 0)
        },
        vat() {
            return this.transactions.reduce((total, item) => {
                return total + Number(item.vat)
            }, 0)
        },
        total() {
            return this.transactions.reduce((total, item) => {
                return total + Number(item.total)
            }, 0)
        },
        productTaxable(){
            return this.products.reduce((total, item) => {
                return total + Number(item.Taxable)
            }, 0)
        },
        productDiscount() {
            return this.products.reduce((total, item) => {
                return total + Number(item.discount)
            }, 0)
        },
        productVat() {
            return this.products.reduce((total, item) => {
                return total + Number(item.VAT)
            }, 0)
        },
        productTotal() {
            return this.products.reduce((total, item) => {
                return total + Number(item.price)
            }, 0)
        },

        otherServiceTaxable(){
            return this.otherServices.reduce((total, item) => {
                return total + Number(item.Taxable)
            }, 0)
        },
        otherServiceDiscount() {
            return this.otherServices.reduce((total, item) => {
                return total + Number(item.discount)
            }, 0)
        },
        otherServiceVat() {
            return this.otherServices.reduce((total, item) => {
                return total + Number(item.VAT)
            }, 0)
        },
        otherServiceTotal() {
            return this.otherServices.reduce((total, item) => {
                return total + Number(item.price)
            }, 0)
        },





        totalTransactionCount(){
            var productTransactions  = _.uniqBy(this.products, 'id');
            return  this.transactions.length + productTransactions.length + this.otherServices.length;
        },
        totalTransactionAmount(){
            var totalServicesAmount = this.transactions.reduce((total, item) => {
                return total + Number(item.taxable)
            }, 0);

            var totalProductsAmount = this.products.reduce((total, item) => {
                return total + Number(item.Taxable)
            }, 0);

             var totalOtherServicesAmount = this.otherServices.reduce((total, item) => {
                return total + Number(item.Taxable)
            }, 0);

            return parseFloat(totalServicesAmount + totalProductsAmount + totalOtherServicesAmount).toFixed(2);
        }
    }
}
</script>





// WEBPACK FOOTER //
// resources/js/Emaar/DailySales.vue